/**
 * @author varun
 */
angular.module('jv.video.jobseeker.list.controller',[])
.controller('VideoListCtrl',['$scope', 'videoService', '$window', '$jobviteUrls', '$timeout', '$rootScope', 'TemplateLoader',
function ($scope, videoService, $window, $jobviteUrls, $timeout, $rootScope, TemplateLoader) {
    $scope.VideoList = null;
    $scope.InterviewStatuses = [{
        'text': $scope.i18n.ALL,
        id: ''
    }, {
        'text': $scope.i18n.COMPLETED,
        id: 'COMPLETE'
    }, {
        'text': $scope.i18n.PENDING,
        id: 'NEW,VIEWED,IN_PROGRESS'
    }, {
        'text': $scope.i18n.EXPIRED,
        id: 'EXPIRED'
    }];

    $scope.templates = TemplateLoader.register({
        requestExtension : 'requestExtension.html'
    });

    $scope.lazyLoading = {};
    $scope.modal = {
        requestExtension: false
    };
    $scope.selectedStatus = null;

    $scope.hideModals = function() {
        $scope.modal = {
            requestExtension: false
        };
        $rootScope.$broadcast('hidingVideoModals');
    };

    $scope.requestExtension = function(args, item) {
        $scope.SId = args;
        $scope.selectedExtensionObjJobTitle = item.jobObj.title;
        TemplateLoader.load('requestExtension').then(function() {
            $scope.$broadcast('requestExtensionModalClick', $scope.SId, $scope.selectedExtensionObjJobTitle);
        });
    };

    // the company hash and the video hash is sent separately. Combine them in one hash.
    function massageList(result) {
        var _companyHash = {};
        var _jobsHash = {};
        var _videoList = [];
        angular.forEach(result.companies, function(company) {
            _companyHash[company.EId] = company;
        });

        angular.forEach(result.jobs, function(job) {
            _jobsHash[job.EId] = job;
        });

        angular.forEach(result.resultList, function(vidList) {
            vidList.companyObj = _companyHash[vidList.companyEId];
            vidList.jobObj = _jobsHash[vidList.jobEId];
            _videoList.push(vidList);
        });
        result.VideoList = _videoList;
        result.totalPages = Math.ceil(result.resultCount / result.pageCount);
        return result;
    }

    // make the call to get the list of video results.
    function getList(page, status) {
        videoService.getList({
            page: page,
            statuses: status
        }, function(result) {
            $scope.result = massageList(result);
            $scope.VideoList = $scope.result.VideoList;
        });
    }

    $scope.getPracticeInterview = function() {
        videoService.getPracticeInterview(null, function(response) {
            if (angular.isDefined(response.bean) && angular.isDefined(response.bean.SId)) {
                $window.location = $jobviteUrls.video + '/video/jobseeker/jobseekerInterview.html#/Interview/Setup/practiceInterview/' + response.bean.SId;
            }
        });
        return false;
    };

    //pagination changes.
    $scope.paginate = function(ifForward) {
        var page = $scope.result.page;
        page = ifForward ? page + 1 : page - 1;
        if (page < 0 || page >= $scope.result.totalPages) {
            return false;
        }
        //getList(page, $scope.selectedStatus.id);
        getList(page, '');
    };
    $scope.$watch('selectedStatus', function(newValue) {
        if (angular.isDefined(newValue) && newValue !== null) {
            //getList(0, $scope.selectedStatus.id);
            getList(0, '');
        }
    });
    // the filter section is hidden for alpha so make this call explicite.
    getList(0, '');
}]);
